import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=3bb0ebd6&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatusBar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusBar.vue
// module id = 2303
// module chunks = 1